export default "__VITE_ASSET__tU0W8E5t__"